module.exports = __webpack_public_path__ + "2540bf10fa81dde377013922ce1f5548.jpg";